<script setup lang="ts">
withDefaults(defineProps<{ label?: string; compact?: boolean; iconOnly?: boolean; tone?: "live" | "warning" | "danger" | "neutral" }>(), { label: "Live", tone: "live" });
</script>

<template><span :class="['live-indicator', `is-${tone}`, { 'is-compact': compact, 'is-icon-only': iconOnly }]" role="status" :title="iconOnly ? label : undefined"><i /><span :class="{ 'sr-only': iconOnly }">{{ label }}</span></span></template>
